import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import Config from 'static/config/coreConfig';

export function getSmallerImage(imageUrl: string | undefined, resolution: EUploadResolution) {
    if (!imageUrl) {
        return imageUrl;
    }

    const isMapheimHosted = imageUrl?.startsWith(Config.StaticContentUrl);

    if (!isMapheimHosted) {
        return imageUrl;
    }

    const parts = imageUrl.split('/');
    return Config.StaticContentUrl + '/' + resolution + '/' + parts[parts.length - 1];
}
